<script lang="ts">
import { ref } from 'vue'

export default (callback:Function) => {
  //対象の要素を<div ref="element"></div>で囲むこと
  const element = ref<HTMLDivElement | null>(null) // 対象の要素
  const isClosing = ref(false);
  const clickOutside = (e: MouseEvent) => {
    // [対象の要素]が[クリックされた要素]を含まない場合
    if (isClosing.value == false && e.target instanceof Node && element.value != null && !(typeof element.value.length !== 'undefined' ? element.value[0]?.contains(e.target) : element.value?.contains(e.target))) {
      callback();
    }
    isClosing.value = false;
  }
  return {
    element,
    isClosing,
    clickOutside,
  }
}
</script>
